import { Directive } from "@angular/core";

@Directive({
    selector: '[t4ListActions]',
    standalone: false
})
  export class ListActionsDirective {}
